import { gsap } from 'gsap';
class SplitHeader {

    constructor() {

        console.log('SplitHeader')

        // eslint-disable-next-line no-unused-vars
        $('.header-split').each(function ( index ) {

            $('.column', this)
              .mouseover(function () {

                console.log('over');

                let info = $('.intro', this);

                gsap.to(info, {opacity: 1})

              }).mouseout(function () {
                let info = $('.intro', this);

                gsap.to(info, {opacity: 0})
              })

        });

    }

}

export default SplitHeader



// WEBPACK FOOTER //
// ./scripts/util/splitHeader.js